import Vue from 'vue';

// Default
import Container from '@/Components/Container';
import PageTitle from '@/Components/PageTitle';
import Icon from '@/Components/Icon';
import ActionBar from '@/Components/ActionBar';

// Base
import BaseCard from '@/Components/Base/Card';
import BaseHeader from '@/Components/Base/Header';
import BaseContent from '@/Components/Base/Content';
import BaseDropdown from '@/Components/Base/Dropdown';
import BaseDropdownLink from '@/Components/Base/DropdownLink';

// Buttons
import DefaultButton from '@/Components/Button/Button';
import CreateButton from '@/Components/Button/CreateButton';
import SaveButton from '@/Components/Button/SaveButton';
import EditButton from '@/Components/Button/EditButton';
import DeleteButton from '@/Components/Button/DeleteButton';

// Element
import ElementBadge from '@/Components/Element/Badge';
import ElementLoadingSpinner from '@/Components/Element/LoadingSpinner';
import ElementModal from '@/Components/Element/Modal';
import ElementPlaceholder from '@/Components/Element/Placeholder';
import ElementTitle from '@/Components/Element/Title';

// Table
import TableBase from '@/Components/Table/Base';
import TableCell from '@/Components/Table/Cell';
import TableHead from '@/Components/Table/Head';
import TablePagination from '@/Components/Table/Pagination';
import TableRow from '@/Components/Table/Row';

// Form
import Checkbox from '@/Components/Form/Input/Checkbox';
import InputDate from '@/Components/Form/Input/Date';
import InputGroup from '@/Components/Form/Input/InputGroup';
import InputPercent from '@/Components/Form/Input/Percent';
import InputCurrency from '@/Components/Form/Input/Currency';
import Multiselect from '@/Components/Form/Multiselect';
import Toggle from '@/Components/Form/Input/Toggle';
import Alert from '@/Components/Form/Alert';
import Help from '@/Components/Form/Help';
import Label from '@/Components/Form/Label';

// Widget
import WidgetStats from '@/Components/Widget/Stats';

// Loading Overlay
import LoadingOverlay from '@/Components/LoadingOverlay';

// Default
Vue.component('container', Container);
Vue.component('page-title', PageTitle);
Vue.component('icon', Icon);
Vue.component('action-bar', ActionBar);

// Base
Vue.component('base-card', BaseCard);
Vue.component('base-header', BaseHeader);
Vue.component('base-content', BaseContent);
Vue.component('base-dropdown', BaseDropdown);
Vue.component('base-dropdown-link', BaseDropdownLink);

// Element
Vue.component('element-loading-spinner', ElementLoadingSpinner);
Vue.component('element-placeholder', ElementPlaceholder);
Vue.component('element-badge', ElementBadge);
Vue.component('element-modal', ElementModal);
Vue.component('element-title', ElementTitle);

// Buttons
Vue.component('default-button', DefaultButton);
Vue.component('create-button', CreateButton);
Vue.component('save-button', SaveButton);
Vue.component('edit-button', EditButton);
Vue.component('delete-button', DeleteButton);

// Table
Vue.component('table-base', TableBase);
Vue.component('table-cell', TableCell);
Vue.component('table-head', TableHead);
Vue.component('table-pagination', TablePagination);
Vue.component('table-row', TableRow);

// Form
Vue.component('checkbox', Checkbox);
Vue.component('datepicker', InputDate);
Vue.component('input-group', InputGroup);
Vue.component('input-percent', InputPercent);
Vue.component('input-currency', InputCurrency);
Vue.component('multiselect', Multiselect);
Vue.component('toggle', Toggle);
Vue.component('form-alert', Alert);
Vue.component('form-help', Help);
Vue.component('form-label', Label);

// Widgets
Vue.component('widget-stats', WidgetStats);

// Loading Overlay
Vue.component('loading-overlay', LoadingOverlay);
